import { useState } from "react";

export default function Image(props) {
	const [loaded, setLoaded] = useState(false);
	const [error, setError] = useState(false);

	const handleLoad = () => {
		setLoaded(true);
	};

	const handleError = () => {
		setLoaded(true);
		setError(true);
	};

	return (
		<>
			{error && loaded ? (
				<img
					{...props}
					alt="default image"
					src="/Assets/default.png"
					loading="lazy"
				/>
			) : (
				<img
					{...props}
					onLoad={handleLoad}
					loading="lazy"
					onError={handleError}
				/>
			)}
		</>
	);
}
